<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <PublicBanner text="همسطح سازی سوابق چیست؟" />
        <h4>همسطح سازی سوابق آموزشی ،تحصیلی ،شغلی و بیمه ای چیست؟</h4>
        <p>
          ارزیابی، تجمیع و استاندارد سازی دوره های پودمانی آموزشی، دوره های ضمن
          خدمت، تجربیات و سوابق کاری، بیمه و مقالات‌ ، کتاب و تبدیل آن به
          گواهینامه‌های همسطح دیپلم تا دکتری و قابل استعلام از موسسه می باشد.
        </p>
        <h4>... چرا همسطح سازی !؟</h4>
        <p>
          همسطح سازی سوابق آموزشی در واقع اثبات کننده این است که افراد توانایی
          هایی ثبت شده دارند و می توانند آن را یکجا و در قالب یک گواهینامه
          استاندارد ارائه کنند،این گواهینامه قابل استفاده در برخی ادارات و
          سازمان ها نسبت به استانداردها است‌. همسطح سازی سوابق آموزشی جلوگیری می
          کند از اتفاق بی ارزشی به نام مدرک فروشی غیرقانونی و جعل در مدارک و
          رویکرد افراد را به اینگونه مدارک غیر قانونی و جعلی کم میکند.
        </p>
        <p>
          همسطح سازی سوابق آموزشی ، طبق آموزش هایی که افراد آموزش دیده اند صادر
          می شود و این یعنی سازماندهی ساعت های آموزشی در یک چهار چوب کلی طبق
          قوانین و اساس نامه موسسه تعریف شده اند.
        </p>
        <p>
          همسطح سازی سوابق آموزشی در مهرآوران دانش پژوهان البرز را در بعضی
          سازمان ها و نهاد ها به عنوان طی کردن دوره های عرضی قبول دارند .
        </p>
        <p>
          همسطح سازی سوابق آموزشی در مهرآوران دانش پژوهان البرز می تواند برای
          موسسات و آموزشگاه ها و سازمان ها ،جایگزین مناسبی به جای مدرک تحصیلی و
          جایگاه قرارگیری در رزومه تحصیلی را دارد.
        </p>
        <h3>درباره گواهینامه :</h3>
        <p>
          پذیرش گواهینامه‌های این مرکز در دانشگاه‌های داخلی کشور به دلیل اصول و
          ساختار آکادمی بودن آنها جهت ادامه تحصیل امکان‌پذیر نبوده ولی در برخی
          از موسسات آموزش عالی و دانشگاهی غیر دولتی داخل و برخی دانشگاه‌ها و
          موسسات آموزش عالی دولتی و غیر دولتی خارج از کشور مورد پذیرش قرار گرفته
          ‌است .
        </p>
        <p>
          از نظر استخدام کشوری از طرف تعداد کمی از سازمان‌ها و نهادهای دولتی بر
          اساس اصول و ساختار داخلی کارگزینی , بنا به تشخیص نهاد به دلیل داشتن
          استاندارد تخصصی و کابردی منحصر به فرد مورد پذیرش قرار گرفته است، ولی
          هنوز در لیست پذیرش گواهینامه‌های نوع دوم دولت وارد نشده است.
        </p>
        <p>
          لازم به یادآوری است گواهینامه‌های این مرکز طبق دستور اقدام عملی معاونت
          توسعه مدیریت و منابع انسانی ریاست محترم جمهوری اسلامی در روزهای پایانی
          دولت دهم با این عنوان که گواهینامه‌های صادره از این مرکز از نوع
          گواهینامه‌های نوع دوم فرض گردد که در ارتقاء یک مقطع کارکنان دولت محسوب
          شود، در مراحل پایانی بود که در دولت یازدهم جهت ابلاغ نهایی پیگیر آن
          می‌باشیم.
        </p>
        <h3>
          روش کار تجمیع، استاندارد سازی و ارزشیابی و همسطح سازی سوابق آموزشی به
          گواهینامه‌ های همسطح به این صورت است که:
        </h3>
        <p>
          ابتدا شما دوست عزیز آخرین مدرک تحصیلی خویش را به همراه تمام دوره های
          آموزشی که ممکن است گذرانده باشید (زیر نظر فنی حرفه‌ای، وزارت ارشاد،
          وزارت علوم، دوره های ضمن خدمت،گواهی‌ شرکت‌ در سمینار و …) همچنین سوابق
          پژوهشی خویش را کپی کرده و یا از طریق اینترنت ارائه‌ میدهید .
        </p>
        <p>
          بعد از ارائه مدارک ؛ نماینده و ارزیاب مدارک پردیس پس از بررسی به شما
          اعلام میکند که سوابق ارایه شده تا چه سطحی میتواند همسطح سازی شود.
        </p>
        <p>
          بنابراین طبق مدارکی که شما در اختیار ما قرار میدهید پروسه‌ تجمیع‌،
          استاندارد و ارزشیابی تحصیلی و همسطح‌ سازی را در حد گواهینامه‌ همسطح
          کاردانی تا گواهینامه همسطح دکتری انجام خواهیم داد.
        </p>
        <p class="green white--text rounded text-center py-3">
          باشد که بتوانیم قدمی موءثری‌ در پیشبرد‌ و پیشرفت‌ شما عزیزان‌ برداریم
          موفقیت‌ شما عزیزان‌ آرزوی‌ قلبی ماست…
        </p>
        <p class="font-weight-bold orange--text">
          توجه داشته باشید:این گواهینامه ها صرفا جهت تجمیع سوابق آموزشی‌ پراکنده
          و به در خواست نامبرده صادر میشود و به هیچ عنوان مدرک معادل یا مدرک
          دانشگاهی تلقی نشده و نمیشود! و زیرنظر وزارت علوم تحقیقات‌ و فناوری و
          وزارت بهداشت نمی باشد ولی قانونمند می باشد و دارای استعلام به سه طریق
          می باشد .
        </p>
        <h3>اصول و ساختار مرکز تعیین و ارتقاي سطح :</h3>
        <p>
          توسعه ارتقا، سطح تخصصی و مهارتی کاربردی با هدف کارآفرینی در شرایط
          کنونی برای اقتصاد و فرهنگ ایران یک امر حیاتی محسوب می شود، زیرا سرمایه
          گذاری‌های زیر بنایی و افزایش ابزار و تجهیزات و بطور کلی سرمایه‌های
          فیزیکی بدون سرمایه انسانی بلااستفاده خواهد ماند. زندگی شغلی افراد باید
          مولد و همراه با توسعه دانش کاربردی باشد تا قادر شوند با سرعت تغییر
          هماهنگ شوند، لذا داشتن دانش کاربردی مهارتی برای موفقیت اقتصادی و
          اجتماعی افراد ضروری است.
        </p>
        <h3>توسعه دانش تخصصی و کاربردی مهارتی برای کارفرمایان :</h3>
        <p>افزایش بهره‌وری، بهبود عملکرد و افزایش سودآوری</p>
        <h3>برای جامعه :</h3>
        <p>ارتقاء سلامتی، افزایش مشارکت، افزایش تحرک و انسجام اجتماعی</p>
        <h3>برای افراد :</h3>
        <p>
          تسهیل در ورود شغل، پایداری شغل، توانایی حرکت میان شغل‌ها، افزایش نرخ
          موفقیت شروع به کارها، افزایش سطح دستمزد، افزایش میزان رضایت، افزایش
          اشتغال و کارآفرینی و کاهش رکود اقتصادی را به ارمغان خواهد آورد.
        </p>
        <p>
          بدین سبب مركز تعیین و ارتقاء سطح علوم تخصصی و کاربردی مهارتی مهرآوران
          دانش پژوهان البرز با تدوین و تنظیم استاندارد تخصصی نسبت به تعیین سطح
          افراد متخصص و ماهر در سطوح مختلف به اقدام و گواهینامه تخصصی و کاربردی
          مهارتی را صادر می‌نماید.
        </p>
        <p>
          این مدارک و گواهینامه در تمام رشته ها غیر از پزشکی و پیرا پزشکی متناسب
          با سوابق و دوره ها و سنوات و تجارب مورد تایید، صادر میگردد.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PublicBanner from "@/packages/public/components/PublicBanner";
export default {
  name: "WhatDetermining",
  components: { PublicBanner },
};
</script>

<style scoped>
h3 {
  margin-bottom: 1rem;
  font-size: 20px;
}
p {
  font-weight: bold;
  font-size: 18px;
}
</style>
